import api from './config';

export interface AdminBrandItem {
  id: number;
  brand_id: string;
  brand_name: string;
  instagram_username: string | null;
  instagram_id: string | null;
  instagram_token: string | null;
  tiktok_username: string | null;
  tiktok_id: string | null;
  created_at: string;
  updated_at: string;
}

export interface CreateBrandRequest {
  brand_id: string;
  brand_name: string;
  instagram_username?: string;
  instagram_id?: string;
  instagram_token?: string;
  tiktok_username?: string;
  tiktok_id?: string;
}

export interface UpdateBrandRequest {
  brand_id?: string;
  brand_name?: string;
  instagram_username?: string;
  instagram_id?: string;
  instagram_token?: string;
  tiktok_username?: string;
  tiktok_id?: string;
}

interface PaginatedResponse<T> {
  success: boolean;
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

export const brandManagementService = {
  async getBrands(params: {
    page?: number;
    limit?: number;
    search?: string;
  } = {}): Promise<PaginatedResponse<AdminBrandItem>> {
    const response = await api.get('/admin/brand', { params });
    return response.data;
  },

  async createBrand(data: CreateBrandRequest): Promise<{ success: boolean; data: AdminBrandItem }> {
    const response = await api.post('/admin/brand', data);
    return response.data;
  },

  async updateBrand(id: number, data: UpdateBrandRequest): Promise<{ success: boolean; data: AdminBrandItem }> {
    const response = await api.put(`/admin/brand/${id}`, data);
    return response.data;
  },

  async deleteBrand(id: number): Promise<{ success: boolean; message: string }> {
    const response = await api.delete(`/admin/brand/${id}`);
    return response.data;
  },
};
